import { createSlice, configureStore, createAction } from "@reduxjs/toolkit";
import { EventApi, useCreateEventQuery } from "./Api/ApiCall";
import { setupListeners } from "@reduxjs/toolkit/dist/query";

const resetData = createAction("user/disconnect");

const walletData = createSlice({
  name: "walletAddress",
  initialState: {
    walletAddress: null,
    signer: {},
    provider: {},
    contract: null,
  },
  reducers: {
    setWallet(state, action) {
      state.walletAddress = action.payload;
    },
    setProvider(state, action) {
      console.log("stored provider serialized data")
      state.provider = JSON.parse(action.payload);
    },
    setSigner(state, action) {
      console.log("store serialized data")
      state.signer = JSON.parse(action.payload);
    },
    setContract(state, action) {
      state.contract = action.payload;
    },
  },
});

const store = configureStore({
  reducer: {
    userData: walletData.reducer,
    [EventApi.reducerPath]:EventApi.reducer
  },
  middleware:(getDefaultMiddleware)=>{
    return getDefaultMiddleware().concat(EventApi.middleware)
  }
});

setupListeners(store.dispatch)
export { store };


export {useCreateEventQuery} from './Api/ApiCall'
export const { setWallet, setContract, setSigner, setProvider } =
  walletData.actions;
